const meet_labels = {
    IT: {
        // Breadcrumb Navigation
        home: "Home",
        meet: "Meet",

        // Table Headers
        type: "Tipo",
        url: "Url",
        time: "Tempo",

        // Modal Titles and Messages
        joinMeetTitle: "Entra in un meet",
        joinMeetLabel: "Inserisci l'url del meet",
        meetPlatformsHelper: "(google meet, microsoft teams, zoom, webex)",
        
        aiRecordingTitle: "Registrazione AI",
        aiRecordingMessage: "La registrazione AI sta iniziando... Attendere prego...",

        stillThereTitle: "Sei ancora lì?",
        stillThereMessage: "Ehi? Sei ancora lì? Premi il pulsante OK altrimenti chiuderò la connessione...",

        meetTitle: "Meet",
        meetConcludedMessage: "Il meet è concluso",
        stopRecordingConfirm: "Vuoi interrompere la registrazione?",

        // UI Labels
        meetsMonitorTooltip: "Monitor meet",
        joinMeetTooltip: "Entra in un meet",
        stopRecording: "interrompi registrazione",

        // Meet Details
        startedAt: "Iniziato alle",
        status: "Stato",
        participants: "Partecipanti",

        // Main Page
        activeMeetsTitle: "Meet attivi",
        activeMeetsDescription: "Questo è un monitor in tempo reale di tutti i meet attivi gestiti dal sistema",

        // Button Text (from meet_jump_screen.js)
        button: "Pulsante"
    },
    EN: {
        // Breadcrumb Navigation
        home: "Home",
        meet: "Meet",

        // Table Headers
        type: "Type",
        url: "Url",
        time: "Time",

        // Modal Titles and Messages
        joinMeetTitle: "Join a meet",
        joinMeetLabel: "Give me the url of the meet",
        meetPlatformsHelper: "(google meet, microsoft teams, zoom, webex)",
        
        aiRecordingTitle: "AI recording",
        aiRecordingMessage: "The AI recording is starting... Please hold...",

        stillThereTitle: "Still there?",
        stillThereMessage: "Hei? Are you still there? Please tap OK button otherwhise I'll close the connection...",

        meetTitle: "Meet",
        meetConcludedMessage: "Meet has concluded",
        stopRecordingConfirm: "Do you want to stop recording?",

        // UI Labels
        meetsMonitorTooltip: "Meets monitor",
        joinMeetTooltip: "Join a meet",
        stopRecording: "stop recording",

        // Meet Details
        startedAt: "Started at",
        url: "Url",
        status: "Status",
        participants: "Partecipants",

        // Main Page
        activeMeetsTitle: "Active meets",
        activeMeetsDescription: "This is a real-time monitor of all the active meets managed by the system",

        // Button Text (from meet_jump_screen.js)
        button: "Button"
    }
};

const MeetLabels = {
    it: meet_labels.IT,
    en: meet_labels.EN
};

export { MeetLabels }; 